const imageWrapperSelector = `.gatsby-image-wrapper`;
const imageSelector = `${imageWrapperSelector} picture img`;
const imageBackgroundSelector = `${imageWrapperSelector}  > img`;
exports.imageWrapperSelector = imageWrapperSelector;
exports.imageSelector = imageSelector;
exports.imageBackgroundSelector = imageBackgroundSelector;